export default {
  SET_SYNONYMS(state, payload) {
    state.wasteGroupSynonyms = payload
  },
  SET_WASTE_STREAMS(state, payload) {
    state.wasteStreams = payload
  },
  SET_ACTIVE_WASTE_STREAM_ID(state, id) {
    state.activeWasteStreamId = id
  },
  SET_IS_WASTE_STREAM(state, bool) {
    state.isWasteStream = bool
  },
  SET_ACTIVE_SYNONYM(state, payload) {
    if (typeof payload === 'string' || payload === null) {
      state.activeSynonym = payload
    } else {
      throw new TypeError('Payload must be of type String or must be null')
    }
  },
  SET_ACTIVE_WASTETYPE(state, payload) {
    if (typeof payload === 'object' && !Array.isArray(payload)) {
      state.activeWasteType = payload
    } else {
      throw new TypeError('Payload must be of type Object')
    }
  },
  SET_SHOW_RESULTS(state, payload) {
    state.showResults = payload
  }
}
